import { IAPIGameItem } from '../../model/api-modules/game';
import extGameIcon from '../../assets/images/ext-game-icon.png';
const GAME_ICON = [
  // 默认游戏图标
  'https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/gcloud_platform/Home/icon-game-list-01.png',
  'https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/gcloud_platform/Home/icon-game-list-02.png',
  'https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/gcloud_platform/Home/icon-game-list-03.png',
  'https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/gcloud_platform/Home/icon-game-list-04.png',
];
export const DEFAULT_GAME_ICON =
  'https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/gcloud_oversea/console-frontend/images/53f4fb70-49d1-11ed-9731-a9504b135a8c1665539892389.png';

export const getDefaultGameIcon = (game: IAPIGameItem | null) => {
  if (!game) {
    return GAME_ICON[1 % GAME_ICON.length];
  }
  // EXT游戏的icon
  if (game.gameID === '292438711') {
    return extGameIcon;
  }
  return GAME_ICON[Number(game.gameID) % GAME_ICON.length];
};

/**
 * 计算字符串对应的字节长度
 */
export function countStrLength(str: string) {
  const strLen = str ? str.length : 0;

  let countLen = 0;
  let charCode = 0;
  for (let i = 0; i < strLen; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      countLen += 1; // ascii码为1个字节长度
    } else {
      countLen += 3; // 非ascii码以3个字节长度计算
    }
  }
  return countLen;
}

export const splitEmail = (email?: string) => {
  if (email) {
    const arr = email.split('@');
    return arr[0];
  }
  return '';
};
